import { Component } from 'react';
import { compose } from 'recompose';
import _ from 'lodash';
import { combineStyles } from 'helpers/helpers';
import { get, post, put } from 'helpers/apiHelpers';
import withStyles from '@material-ui/core/styles/withStyles';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const DietDelivery = WrappedComponent =>
  // eslint-disable-next-line react/display-name -- FIXME
  class extends Component {
    state = {
      deliveryPrices: [],
      isLoading: true,
    };

    componentDidMount() {
      Promise.all([
        get('/zone-costs', { pagination: false }),
        get('/zones?properties[]=name&properties[]=id', { pagination: false }),
        // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      ]).then(([zoneCostsResponse, zoneDetailsResponse]) => {
        const zoneCosts = zoneCostsResponse['hydra:member'];
        const zoneDetails = zoneDetailsResponse['hydra:member'];

        const zones = zoneDetails.map(element => ({
          hasChanged: false,
          zone: element['@id'],
          dietCostsId: _.get(
            zoneCosts.find(el => el.zone === element['@id']),
            '@id'
          ),
          name: element.name,
          vat: _.get(
            zoneCosts.find(el => el.zone === element['@id']),
            'vat',
            ''
          ),
          price: _.get(
            zoneCosts.find(el => el.zone === element['@id']),
            'price',
            ''
          ),
          _vat: _.get(
            zoneCosts.find(el => el.zone === element['@id']),
            'vat',
            ''
          ),
          _price: _.get(
            zoneCosts.find(el => el.zone === element['@id']),
            'price',
            ''
          ),
          cost: _.get(
            zoneCosts.find(el => el.zone === element['@id']),
            'cost',
            ''
          ),
        }));

        this.setState({
          deliveryPrices: zones,
          isLoading: false,
        });
      });
    }

    handleChange = (name, value, zone) => {
      const { deliveryPrices } = this.state;
      const zoneIndex = deliveryPrices.findIndex(
        price => price.zone === zone.zone
      );
      deliveryPrices[zoneIndex][name] = value;

      deliveryPrices[zoneIndex].hasChanged =
        deliveryPrices[zoneIndex][`_${name}`] !== parseFloat(value);

      this.setState({ deliveryPrices });
    };

    validateForm = () => {
      const { t } = this.props;
      const { deliveryPrices } = this.state;
      let isValid = true;

      if (
        deliveryPrices.some(
          deliveryPrice =>
            deliveryPrice.price === '' ||
            deliveryPrice.vat === '' ||
            deliveryPrice.cost === ''
        )
      ) {
        isValid = false;
        toast.error(t('prices.toast.notEmpty'));
      }
      if (
        deliveryPrices.some(
          deliveryPrice =>
            isNaN(deliveryPrice.price) ||
            isNaN(deliveryPrice.vat) ||
            isNaN(deliveryPrice.cost)
        )
      ) {
        isValid = false;
        toast.error(t('prices.toast.mustBeNumb'));
      }
      return isValid;
    };

    saveAll = () => {
      if (!this.validateForm()) {
        return;
      }

      const { deliveryPrices } = this.state;
      deliveryPrices.forEach(deliveryPrice => {
        if (deliveryPrice.price !== '') {
          deliveryPrice.price = parseFloat(deliveryPrice.price);
        }
        if (deliveryPrice.vat !== '') {
          deliveryPrice.vat = parseFloat(deliveryPrice.vat);
        }
        if (deliveryPrice.cost !== '') {
          deliveryPrice.cost = parseFloat(deliveryPrice.cost);
        }
      });

      // eslint-disable-next-line consistent-return -- FIXME
      return Promise.all(
        deliveryPrices.map(deliveryPrice => {
          if (deliveryPrice.hasChanged) {
            // eslint-disable-next-line no-negated-condition -- FIXME
            return deliveryPrice.dietCostsId !== undefined
              ? put(deliveryPrice.dietCostsId, deliveryPrice)
              : post('/zone-costs', deliveryPrice);
          }
          return null;
        })
        // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      ).then(() => {
        deliveryPrices.forEach(price => {
          price.hasChanged = false;
        });
        toast.success(this.props.t('success.changesSaved'));
        this.setState({
          deliveryPrices: deliveryPrices.map(price => ({
            ...price,
            _price: price.price,
            _vat: price.vat,
          })),
        });
      });
    };

    render() {
      return (
        <WrappedComponent
          {...this.state}
          classes={this.props.classes}
          handleChange={this.handleChange}
          saveAll={this.saveAll}
        />
      );
    }
  };

const combinedStyles = combineStyles(
  extendedFormsStyle,
  validationFormsStyle,
  buttonsStyle
);

export default compose(
  withStyles(combinedStyles),
  withTranslation(),
  DietDelivery
);
